'use client';

import { c as _c } from "react/compiler-runtime";
import { SearchResultList } from "@/features/search-result/ui/organisms";
import { FilterValue, Region } from "@/shared/types/type/search";
import { Filter } from "@/widgets/search/ui/molecules";
import { SearchBar, AutoComplete } from "@/features/search/ui";
import { useSearchUiPersistStore, useSearchUiStore } from "@/features/search/model/ui/store";
import { useEffect } from "react";
interface SearchResultTemplateProps {
  regionList: Region[];
  treatmentList: FilterValue[];
}
const SearchResultTemplate = t0 => {
  const $ = _c(17);
  const {
    regionList,
    treatmentList
  } = t0;
  const {
    keyword,
    isSearchBarFocused,
    setIsSearchBarFocused
  } = useSearchUiStore();
  const showAutoComplete = isSearchBarFocused && keyword.length >= 2;
  let t1;
  let t2;
  if ($[0] !== setIsSearchBarFocused) {
    t1 = () => {
      useSearchUiPersistStore.persist.rehydrate();
      return () => {
        setIsSearchBarFocused(false);
      };
    };
    t2 = [setIsSearchBarFocused];
    $[0] = setIsSearchBarFocused;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== showAutoComplete) {
    t3 = () => {
      if (showAutoComplete) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    };
    t4 = [showAutoComplete];
    $[3] = showAutoComplete;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  const t5 = `bg-white flex-1 flex flex-col min-h-screen ${showAutoComplete ? "h-dvh" : ""}`;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SearchBar backButton={true} />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== regionList || $[8] !== treatmentList) {
    t7 = <div className="sticky top-0 z-10 shrink-0 bg-white">{t6}<Filter regionList={regionList} treatmentList={treatmentList} /></div>;
    $[7] = regionList;
    $[8] = treatmentList;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== showAutoComplete || $[11] !== treatmentList) {
    t8 = showAutoComplete ? <div className="min-h-0 flex-1 overflow-y-auto bg-white"><AutoComplete /></div> : <SearchResultList treatmentList={treatmentList} />;
    $[10] = showAutoComplete;
    $[11] = treatmentList;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t7 || $[15] !== t8) {
    t9 = <section className={t5}>{t7}{t8}</section>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};
export default SearchResultTemplate;